import { useState } from 'react';

import constate from 'constate';

function useAnnouncements() {
    const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

    const openSidePanel = () => setIsSidePanelOpen(true);
    const closeSidePanel = () => setIsSidePanelOpen(false);

    return {
        isSidePanelOpen,
        openSidePanel,
        closeSidePanel,
    };
}

const [AnnouncementsContextProvider, useAnnouncementsContext] = constate(useAnnouncements);

export { AnnouncementsContextProvider, useAnnouncementsContext };
